import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TimelineStep {
  phase: string;
  duration: string;
  activities: string[];
}

interface ProcessTimelineProps {
  steps: TimelineStep[];
}

const ProcessTimeline = ({ steps }: ProcessTimelineProps) => {
  return (
    <div className="relative">
      <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-border hidden md:block"></div>
      
      <div className="space-y-8">
        {steps.map((step, index) => (
          <div key={index} className="relative flex items-start space-x-4">
            <div className="flex-shrink-0 w-16 h-16 bg-primary text-primary-foreground rounded-full flex items-center justify-center font-display font-bold text-lg shadow-subtle z-10">
              {index + 1}
            </div>
            
            <div className="flex-1 bg-card rounded-lg p-6 shadow-subtle border border-border">
              <div className="flex items-center justify-between mb-3">
                <h4 className="text-lg font-display font-bold text-foreground">{step.phase}</h4>
                <span className="px-3 py-1 bg-accent/10 text-accent rounded-full text-sm font-medium">
                  {step.duration}
                </span>
              </div>
              
              <ul className="space-y-2">
                {step.activities.map((activity, actIndex) => (
                  <li key={actIndex} className="flex items-start space-x-2 text-sm text-foreground">
                    <Icon name="CheckCircleIcon" size={16} className="text-success flex-shrink-0 mt-0.5" />
                    <span>{activity}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProcessTimeline;